import React, { useState } from "react";
import "./dynamicListView.scss";
import { accounts } from "../../../models/AccountsModel";
import { ReactComponent as MenuItems } from "../../../images/menu-dots.svg";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { productDataModel } from "../../../models/ProductsModel";
import { actionItemsModel } from "../../../models/ActionModel";
import { InteractionHistoryModal } from "../../../models/InteractionHistoryModel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines } from "@fortawesome/free-solid-svg-icons";
import { getAmountValue, textFormatter } from "../../../utils/GeneralUtils";
import { ReactComponent as DocumentsIcon } from "../../../images/Paperclip.svg";
import { ReactComponent as UserIcon } from "../../../images/user.svg";
import { ReactComponent as Pdf } from "../../../images/pdf.svg";
import { textReadableFormat } from "../../../utils/Utils";

interface customerActivity {
  name: string;
  sessionTime: string;
  sessionStart: string;
  sessionEnd: string;
  Date: string;
}

interface Document {
  clientActionDocumentId: string;
  documentPath: string;
  documentName: string;
}

type DocumentList = Document[];

export default function DynamicListView(props: any) {
  const [selectedTileDetail, setSelectedTileDetail] = useState<any>();
  const [dropDownValues, setDropDownValues] = useState<any>();
  const [dropDown, setDropDown] = useState<boolean>(false);
  const { tilesData, columnNames } = props;
  const [selectedUuid, setSelectedUuid] = useState("");

  const toggleUuid = (object: any) => {
    setSelectedUuid(object.uuid === selectedUuid ? "" : object.uuid ?? "");
    setDropDownValues(object.text);
  };

  const columnContainer = (object: any) => {
    switch (object.displayText) {

      case 1:
        return (
          <div className={`${object.columnStyling}`}>
            <div className={`displayTextContainer`}>
              <p className="label">{object.displayLabelText}</p>
              <p
                className={`text ${object?.condition ? object?.condition(object.text) : ""
                  } ${object?.textStyling ? object.textStyling : ""}`}
              >
                {(object.label !== "estimatedValues" && object.label !== "estimatedvalue")
                  ? textFormatter(object.text)
                  : getAmountValue(object.text)}
              </p>
            </div>
          </div>
        );

      case 2:
        return (
          <div
            className={`${object.columnStyling} ${object?.displayLabelText === "NOTES" ? "notes-tooltip" : ""}`}
            onClick={
              object?.operation && object?.text
                ? () => object?.operation(object)
                : undefined
            }
          >
            <div className="displayTextContainer">
              <p className="label ">{object?.displayLabelText}</p>
              {object?.text ? (
                <Dropdown
                  isOpen={
                    selectedUuid === object?.uuid &&
                    dropDownValues === object.text
                  }
                  toggle={() => toggleUuid(object)}
                  className="menuContainer actionSVGs"
                  title=""
                >
                  <DropdownToggle className="menuContainerButton">
                    {object.label !== "documents" ? <FontAwesomeIcon icon={faFileLines} /> : <div className="d-flex mt-1"><span className="documentsDataText">
                      {`(${JSON.parse(object.text).length})`}</span><DocumentsIcon className="documentsIcon" /></div>}
                  </DropdownToggle>
                  <DropdownMenu className="dropdownMenuData">
                    <div className="dropdownMenuData-inner">
                      {object.label !== "documents" ? <div className="headingContainer"><FontAwesomeIcon icon={faFileLines} /> <span className="dropdownTitle">Notes</span></div> :
                        <div className="headingContainer document-icon"><DocumentsIcon /> <span className="dropdownTitle">Documents</span></div>}
                      {object.label === "documents" ? (
                        JSON.parse(object.text)?.map((document: Document) => (
                          <DropdownItem key={document.clientActionDocumentId} onClick={() => object.condition(document)}>
                            <DocumentsIcon className="documentsIcon" />
                            <span className="document-name">{document.documentName}</span>
                          </DropdownItem>
                        ))
                      ) : (
                        <DropdownItem disabled className="notesDropdown">{object?.text}</DropdownItem>
                      )}</div>
                  </DropdownMenu>
                </Dropdown>
              ) : (
                <div className="emptyContainer">--</div>
              )}
            </div>
          </div>
        );

      case 3:
        return (
          <div className={`${object.columnStyling}`}>
            <div className="displayTextContainer">
              <p
                className={`text ${object?.condition ? object?.condition(object.text) : ""
                  } ${object?.textStyling ? object.textStyling : ""} ${object.text === "active" ? "activeState" : ""
                  }`}
              >
                {object.text}
              </p>
            </div>
          </div>
        );

      case 4:
        return (
          <div className={`${object.columnStyling}`}>
            <div className={`displayTextContainer d-flex`}>
              <p className="label flexTypeData">{object.displayLabelText}</p>
              {object.text ? <p
                className={`text ${object.condition ? object.condition(object.text) : ""
                  } ${object?.textStyling ? object.textStyling : ""}`}
              >
                { }
                {object.timeConversion ? object.timeConversion(object.text) : object.removeMilliSeconds ? object.removeMilliSeconds(object.text) : object.text}
              </p> : (
                <div className="emptyContainer">--</div>
              )}
            </div>
          </div>
        );

      case 5:
        return (
          <div className={`${object.columnStyling}`}>
            <div className="displayTextContainer">
              <p
                className={`text ${object?.condition ? object?.condition(object.text) : ""
                  } ${object?.textStyling ? object.textStyling : ""} ${object.text === "active" ? "activeState" : ""}`}
              >
                {textFormatter(object.productAndAccount)}
              </p>
            </div>
          </div>
        );
      case 6:
        return (
          <div className={`${object.columnStyling}`}>
            <div className={`displayTextContainer`}>
              <p className="label">{object.displayLabelText}</p>
              <p
                className={`text ${object?.condition ? object?.condition(object.text) : ""
                  } ${object?.textStyling ? object.textStyling : ""}`}
              >
                {(object.label !== "estimatedValues" && object.label !== "estimatedvalue")
                  ? textFormatter(object.text)
                  : getAmountValue(object.text)}
              </p>
              <div className="reassignName">
                <UserIcon /><span>{object.mappingValue}</span>
              </div>
            </div>
          </div>
        );


      default:
        return <>- -</>;
    }
  };

  const rowDisplayingData = (m: any) => {
    const productsmodifiedData: any[] = [];
    Object.entries(m).map(([key, value]) => {
      const row = columnNames?.find((m: any) => m.label === key);
      let mappingValue = "";
      if (row?.mappingName) {
        mappingValue = m[row.mappingName]
      }
      if (row)
        return productsmodifiedData.push({
          ...row,
          text: value,
          uuid: m?.clientActionId,
          mappingValue: mappingValue,
          productAndAccount: m.productname + "- ACCT: " + textFormatter(m.account),
        });
    });
    return productsmodifiedData
      ?.sort((a, b) => a.orderId - b?.orderId)
      ?.map((obj: any, index: number) => (
        <div key={index} className="min-columns">{columnContainer(obj)}</div>
      ));
  };

  const toggle = (m: any) => {
   
    setDropDown(!dropDown);
    setSelectedTileDetail(m);
  };

  const dropDownMenu = (tileDetail: any) => {
    return (
      <Dropdown
        isOpen={dropDown && tileDetail === selectedTileDetail}
        toggle={() => toggle(tileDetail)}
        className="menuContainer"
      >
        <DropdownToggle className="menuContainerButton">
          <MenuItems title="" />
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={() => props.modalCondtion(tileDetail)} >
            Edit
          </DropdownItem>
          {props.className === "actionItemTile" && <DropdownItem onClick={() => props.cancelActionItem(tileDetail)} >
            Cancel
          </DropdownItem>}
        </DropdownMenu>
      </Dropdown>
    );
  };

  return (
    <>
      {tilesData ? (
        tilesData.map(
          (
            m:
              | actionItemsModel
              | productDataModel
              | InteractionHistoryModal
              | customerActivity
              | accounts,
            index: number
          ) => (
            <div className={`d-flex`} key={index} >
              <div className={`d-flex ${props.className}  ${props?.cancelTileStytling ? props?.cancelTileStytling(m) : ""}  ${ (m===selectedTileDetail && dropDown)|| ('clientActionId' in m && m.clientActionId == selectedUuid) ? "selectedTile":""}`}>
                <>{rowDisplayingData(m)}</>
              </div>
              {props.showMenuItems && dropDownMenu(m)}
            </div>
          )
        )
      ) : (
        <div className="noRecordsContainer">
          <p className="not-found">No Records</p>
        </div>
      )}
    </>
  );
}
